export function MenuInner() {
  return (
    <>
      {/* Header menu completamente limpio - solo estructura para futuras expansiones */}
    </>
  )
}
